import {  OfferUpdateImageAndTiner } from "../Model/Offer";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";


export interface GetOfferTimerByIdUseCase {
  invoke: (id: number) => Promise<OfferUpdateImageAndTiner | null>;
}

export class GetOfferTimerById implements GetOfferTimerByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getOfferTimerById(id);
    return getData;
  }
}